<ul class="rc-items">
    <li *ngFor="let option of options" (click)="updateValue(option)" [class.selected]="shouldCheck('radio', option)">
        <input type="radio" [checked]="shouldCheck('radio', option)">
        <label>{{option}}</label>
    </li>
</ul>